import React from 'react'

export default function QueryWarning({message}) {
    return message ? <div role="alert" style={{color: '#ffcc00', margin: '12px 0'}}>Warning: {message}</div> : null
}
